import { useMemo } from "react";
import { useQuery } from "react-query";
import { apiGetCurrencies } from "../utils/queries";

export const useGetCurrency = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["get-currencies"],
    queryFn: async () => await apiGetCurrencies(),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const options = useMemo(() => {
    const currencies = data?.data || [];
    return currencies.map(({ id, currencyCode }) => ({
      value: id,
      label: currencyCode,
    }));
  }, [data]);

  return { options, isLoading, isError };
};

export default useGetCurrency;
